import withStore, { TPresentable, TLoadingAwarePresenter } from "../withStore";
import Application from "../../../Application";
import { TSearchCriteriaFilter } from "../../../search/model/SearchCriteria";

export interface THomePresenter extends TLoadingAwarePresenter {}

export interface IHomePresenter extends THomePresenter, TPresentable {
  onSearch(query: TSearchCriteriaFilter): any;
}

const defaultState: THomePresenter = {};

const HomePresenter = withStore<IHomePresenter, THomePresenter>(
  ({ application, store, loader, translate }): IHomePresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<THomePresenter & TLoadingAwarePresenter>();

    const onSearch = (query: TSearchCriteriaFilter) => {
      let _searchQuery = Object.assign({}, query);
      let queryString = Object.keys(_searchQuery)
        .map((item) => `${item}=${query[item]}`)
        .join("&");
      return _application.navigator.push({
        pathname: "/search",
        search: `?${queryString}`
      });
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      onSearch
    };
  },
  defaultState
);

export default HomePresenter;
